import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTourismActions } from '../../context/TourismContext'

function BannerFour() {
    const { fetchAirbnbHeroSlides } = useTourismActions();
    const [heroSlides, setHeroSlides] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentSlide, setCurrentSlide] = useState(0);

    // Auto-slide functionality
    useEffect(() => {
        if (heroSlides.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
        }, 5000); // Change slide every 5 seconds

        return () => clearInterval(interval);
    }, [heroSlides.length]);

    // Navigation functions
    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    useEffect(() => {
        const loadHeroSlides = async () => {
            try {
                console.log('Loading Airbnb hero slides...');
                const response = await fetchAirbnbHeroSlides();
                console.log('API Response:', response);
                
                // Handle the API response structure
                const slides = response?.results || response || [];
                console.log('Processed slides:', slides);
                setHeroSlides(slides);
            } catch (error) {
                console.error('Error loading hero slides:', error);
                // Fallback data if API fails
                setHeroSlides([{
                    subtitle: "Welcome to Our",
                    title: "Elite Airbnb Services",
                    background_image: "/assets/img/bg/hero_bg_4_1.png",
                    primary_button_text: "Explore Stays",
                    primary_button_link: "/accommodation",
                    secondary_button_text: "Our Services",
                    secondary_button_link: "/service"
                }]);
            } finally {
                setLoading(false);
            }
        };

        loadHeroSlides();
    }, [fetchAirbnbHeroSlides]);

    // Use current slide data or fallback to static content
    const slideData = heroSlides.length > 0 ? heroSlides[currentSlide] : {
        subtitle: "Welcome to Our",
        title: "Elite Airbnb Services",
        background_image: "/assets/img/bg/hero_bg_4_1.png",
        primary_button_text: "Explore Stays",
        primary_button_link: "/accommodation",
        secondary_button_text: "Our Services",
        secondary_button_link: "/service"
    };

    console.log('Current slide data:', slideData);
    console.log('Hero slides array:', heroSlides);
    console.log('Loading state:', loading);

    if (loading) {
        return (
            <div className="th-hero-wrapper bg-bottom-center hero-4" style={{ minHeight: '600px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className="th-hero-wrapper bg-bottom-center hero-4"
            style={{
                backgroundImage: slideData.background_image ? `url(${slideData.background_image})` : "url(/assets/img/bg/hero_bg_4_1.png)",
                backgroundRepeat: "no-repeat",
            }}
            
        >
            <div className="container shape-mockup-wrap">
                <div className="hero-style4 text-center">
                    <span className="sub-title style1">{slideData.subtitle || "Welcome to Our"}</span>
                    <h1 className="hero-title">{slideData.title || "Elite Airbnb Services"}</h1>
                    <div className="btn-group">
                        <Link to={slideData.primary_button_link || "/accommodation"} className="th-btn th-icon">
                            {slideData.primary_button_text || "Explore Stays"}
                        </Link>
                        <Link to={slideData.secondary_button_link || "/service"} className="th-btn style3 th-icon">
                            {slideData.secondary_button_text || "Our Services"}
                        </Link>
                    </div>
                </div>
                <div className="shape-mockup shape1"
                    style={{
                        top: "30%",
                        left: "-9%",
                    }}
                >
                    <img src="/assets/img/shape/shape_1.png" alt="shape" />
                </div>
                <div className="shape-mockup shape2"
                    style={{
                        top: "50%",
                        left: "-10%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2.png" alt="shape" />
                </div>
                <div className="shape-mockup shape3"
                    style={{
                        top: "44%",
                        left: "-16%",
                    }}
                >
                    <img src="/assets/img/shape/shape_3.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup spin d-none d-lg-block"
                    style={{
                        top: "30%",
                        right: "-16%",
                    }}
                >
                    <img src="/assets/img/shape/shape_10.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup d-none d-xl-block"
                    style={{
                        bottom: "-12%",
                        right: "-20%",
                    }}
                >
                    <img src="/assets/img/shape/shape_11.png" alt="shape" />
                </div>
                <div className="shape-mockup spin d-none d-lg-block"
                    style={{
                        bottom: "10%",
                        right: "10%",
                    }}
                >
                    <img src="/assets/img/shape/shape_12.png" alt="shape" />
                </div>

                {/* Slider Navigation - Only show if more than 1 slide */}
                {heroSlides.length > 1 && (
                    <>
                        {/* Previous Button */}
                        <button 
                            className="slider-arrow slider-prev"
                            onClick={prevSlide}
                            style={{
                                position: 'absolute',
                                left: '20px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'rgba(255, 255, 255, 0.2)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '50px',
                                height: '50px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px',
                                color: 'white',
                                transition: 'all 0.3s ease',
                                zIndex: 10
                            }}
                            onMouseOver={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                            onMouseOut={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                        >
                            ‹
                        </button>

                        {/* Next Button */}
                        <button 
                            className="slider-arrow slider-next"
                            onClick={nextSlide}
                            style={{
                                position: 'absolute',
                                right: '20px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'rgba(255, 255, 255, 0.2)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '50px',
                                height: '50px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px',
                                color: 'white',
                                transition: 'all 0.3s ease',
                                zIndex: 10
                            }}
                            onMouseOver={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
                            onMouseOut={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
                        >
                            ›
                        </button>

                        {/* Slide Indicators/Dots */}
                        <div 
                            className="slider-indicators"
                            style={{
                                position: 'absolute',
                                bottom: '30px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                display: 'flex',
                                gap: '10px',
                                zIndex: 10
                            }}
                        >
                            {heroSlides.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToSlide(index)}
                                    style={{
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        background: index === currentSlide 
                                            ? 'white' 
                                            : 'rgba(255, 255, 255, 0.5)'
                                    }}
                                    aria-label={`Go to slide ${index + 1}`}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>

    )
}

export default BannerFour
